var _path, _rect, _path2, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorBaggageSecureWrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.295,33.8l-7.203,5.169-8.42-5.268c-5.367-3.358-8.627-9.243-8.627-15.575V7.318l15.944-4.287,15.967,4.287v11.556c0,5.919-2.852,11.475-7.661,14.926Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.908,
    y: 11.518,
    width: 22.184,
    height: 14.838,
    rx: 2.594,
    ry: 2.594
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.246,9.07h1.508c1.351,0,2.448,1.097,2.448,2.448h-6.404c0-1.351,1.097-2.448,2.448-2.448Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14.202,
    y1: 11.518,
    x2: 14.202,
    y2: 26.355
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 27.798,
    y1: 11.518,
    x2: 27.798,
    y2: 26.355
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorBaggageSecureWrap);
export default __webpack_public_path__ + "static/media/indoor-baggage_secure_wrap.5b52d3bc4b787efbc7c53eb8e28c7cfa.svg";
export { ForwardRef as ReactComponent };